module.exports = __webpack_public_path__ + "static/media/icon-tools.4d978ace.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/featured-cards/icons/icon-tools.png
// module id = 2225
// module chunks = 0